import React, { useContext } from 'react';
import { AddStorageDataContext } from 'context/AddStorageContext';
import styled from 'styled-components';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const RedundantDefault = `${CDN_URL}storage/Storage-redundancy-default.svg`;
const RedundantSelected = `${CDN_URL}storage/Storage-redundancy-selected.svg`;
const NoRedundantDefault = `${CDN_URL}storage/Storage-no-redundancy-default.svg`;
const NoRedundantSelected = `${CDN_URL}storage/Storage-no-redundancy-selected.svg`;

const RedundancyStyle = styled.div`
	display: flex;
	justify-content: center;
	.redundant-selection {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		margin: 10px;
		img {
			cursor: pointer;
			width: 50px;
			height: 50px;
			margin-top: 10px;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.redundant-selection {
			margin: 10px;
			img {
				width: 75px;
				height: 75px;
				margin-top: 15px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.redundant-selection {
			margin: 10px;
			img {
				width: 100px;
				height: 100px;
				margin-top: 25px;
			}
		}
	}
`;

export const RedundancyScreen = () => {
	const { inputs, change } = useContext(AddStorageDataContext);

	const selected = inputs?.redundancy;

	const redundantIcon = selected ? RedundantSelected : RedundantDefault;
	const notRedundantIcon = !selected && selected !== '' ? NoRedundantSelected : NoRedundantDefault;

	return (
		<RedundancyStyle>
			<div className={`redundant-selection redundant ${selected ? 'selected' : ''}`}>
				<div className='title redundant body10'>REDUNDANT</div>
				<img
					src={redundantIcon}
					onClick={() => change({ target: { name: 'redundancy', value: true } })}
					data-cy='redundant'
				/>
			</div>
			<div
				className={`redundant-selection not-redundant ${
					!selected && selected !== undefined ? 'selected' : ''
				}`}
			>
				<div className='title non-redundant body10'>NON-REDUNDANT</div>
				<img
					src={notRedundantIcon}
					onClick={() => change({ target: { name: 'redundancy', value: false } })}
					data-cy='non-redundant'
				/>
			</div>
		</RedundancyStyle>
	);
};
